import BreadCrumbs from 'components/breadcrumbs'
import { Plus } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'
import { URL_WAGE_SALARY_CREATE } from 'utils/pathUrl'
import { useFetchDisburseHistoryListQuery } from '../employee-payments/employeePaymentsListApiSlice'
import { setHistoryFetchOption } from '../employee-payments/employeePaymentsListSlice'
import TabHistory from '../employee-payments/TabHistory'

const WageSalary = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { historyTag } = useSelector((state) => state.employeePaymentsList)

  const { data: disburseHistoryData, isLoading: isLoadingHistory } =
    useFetchDisburseHistoryListQuery(
      {
        page: historyTag?.page,
        size: historyTag?.size,
        sortby: historyTag?.sortby,
        sortdir: historyTag?.sortdir,
        s: historyTag?.search,
      },
      { refetchOnMountOrArgChange: true }
    )

  const handleSetCurrentPage = (page) => {
    dispatch(setHistoryFetchOption({ page }))
  }

  const handleSetRowsPerPage = (size) => {
    dispatch(setHistoryFetchOption({ size, page: 0 }))
  }

  return (
    <div className="w-100 px-3 pb-5 mb-5">
      <div className="mt-3">
        <BreadCrumbs breadCrumbActive="Wage & Salary" />
      </div>

      {/* HEADER SECTION */}
      <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-3">
        <div className="d-flex flex-column">
          <h5
            className="mb-1 fw-bold"
            style={{ fontSize: '24px', letterSpacing: '-0.5px' }}
          >
            Wage & Salary
          </h5>
          <p className="text-muted mb-0" style={{ fontSize: '15px' }}>
            Kelola catatan kerja, pembayaran yang akan dibayarkan, dan ringkasan.
          </p>
        </div>
        <Button
          color="primary"
          className="d-flex align-items-center gap-2 px-3 py-2 fw-semibold shadow-sm"
          style={{
            borderRadius: '8px',
            backgroundColor: '#02678D',
            borderColor: '#02678D',
            cursor: 'pointer',
          }}
          data-testid="wage-salary-add-button"
          onClick={() => navigate(URL_WAGE_SALARY_CREATE)}
        >
          <Plus size={18} />
          <span>Tambah</span>
        </Button>
      </div>

      <Row className="mt-4">
        <Col xs="12">
          <TabHistory
            dataHistory={disburseHistoryData?.items || []}
            totalItems={disburseHistoryData?.totalItems || 0}
            isLoading={isLoadingHistory}
            onViewDetail={(row) => navigate(`/wage-salary/${row.id}`)}
            currentPage={historyTag?.page || 0}
            rowsPerPage={historyTag?.size || 10}
            setCurrentPage={handleSetCurrentPage}
            setRowsPerPage={handleSetRowsPerPage}
          />
        </Col>
      </Row>
    </div>
  )
}

export default WageSalary
